module.exports = __webpack_public_path__ + "img/onboarding_web_4.e1fb3615.png";